export var ErrorType;
(function (ErrorType) {
    ErrorType["INTERNAL"] = "-1";
    ErrorType["FOLIO_EXTERNAL_OR_UNDEFINED"] = "-2";
    ErrorType["EXTERNAL_OR_UNDEFINED"] = "-3";
    ErrorType["UNKNOWN"] = "-4";
    ErrorType["COMPANY_NUMBER_ALREADY_EXISTS"] = "-5";
    ErrorType["PUBLISHER_CANNOT_UPDATE_ANOTHER_PUBLISHER"] = "-6";
    ErrorType["ARES_DATA_NOT_FOUND"] = "-7";
    ErrorType["COMPANY_NUMBER_NOT_FOUND"] = "-8";
    ErrorType["INVALID_WORK_SPECIFICATION"] = "-12";
    ErrorType["MULTIPLE_WORK_SPECIFICATION_FORMATS"] = "-13";
})(ErrorType || (ErrorType = {}));
